import { Button, FormHelperText, Grid, Hidden, IconButton, InputLabel } from '@material-ui/core';
import { TextBox as InputText, UploadWithBadge } from '../../../../Core/FormInput';
import { CustomChip } from '../../../../Core/FormInput/AppChips';
import { memo, useContext } from 'react';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';
import EditIcon from '@material-ui/icons/Edit';
import { CheckFieldType } from '../CheckFieldType';

const CheckButtonsBorder = {
    D: '#d32f2f',
    M: '#f57f17',
    N: '#1976d2',
    S: '#388e3c',
    R: '#d32f2f'
};

export const InspectionCheckBody = memo(({ p, m, CheckButtons, index }) => {
    const { state, flags, changeResutNotesState, changeState, imageHandler, changeNotesState, handleInpectionRow, actionTakenHandle, widths } =
        useContext(InspectionCheCkContaxt);
    const isRetrunedToEnginner = state.isRetrunedToEnginner !== undefined ? state.isRetrunedToEnginner : state.vehicleInspectionStatusID === 3 || true;
    const isReadOnly = Boolean(state.isDisabled || state.vehicleInspectionInspectorSignature);

    const hasValidationError = Object.keys(state.errors || {}).length > 0;

    const isLegalReqError =
        p.inspectionSheetCheckLegalRequirement === true &&
        ((p.inspectionSheetCheckFieldTypeID === 'CO' && !p.inspectionSheetCheckResultOptionCode) ||
            (p.inspectionSheetCheckFieldTypeID !== 'CO' && !p.inspectionSheetCheckResultEnteredText));

    const isListFailed =
        p.inspectionSheetCheckFieldTypeID === 'LT' &&
        state.listOptionsVM.some(
            (k) =>
                k.inspectionSheetListId === p.inspectionSheetCheckListTypeID &&
                k.name === p.inspectionSheetCheckResultEnteredText &&
                (k.setFailed === true || String(k.setFailed).toLowerCase() === 'true')
        );

    const isPhotoMandatoryOnFail =
        p.inspectionSheetCheckPhotoMandatoryOnfail === true ||
        String(p.inspectionSheetCheckPhotoMandatoryOnfail).toLowerCase() === 'true';

    const isPhotoMandatory =
        p.inspectionSheetCheckPhotoMandatory === true ||
        String(p.inspectionSheetCheckPhotoMandatory).toLowerCase() === 'true' ||
        ((p.inspectionSheetCheckResultOptionCode === 'D' || isListFailed) && isPhotoMandatoryOnFail);

    const isPhotoMandatoryError =
        isPhotoMandatory &&
        !(p.photosUploaded > 0 || p.startPhotosUploaded > 0 || p.basicCount > 0);

    const isDefectNoteError =
        (p.inspectionSheetCheckResultOptionCode === 'D' || isListFailed) &&
        (p.inspectionSheetCheckResultNotes == null || p.inspectionSheetCheckResultNotes === '');

    const hasError = hasValidationError && (isLegalReqError || isPhotoMandatoryError || isDefectNoteError);

    const rowBg = index % 2 === 0 ? '#ffffff' : '#f8fafc';

    if (p.inspectionSheetSectionSeprator && !p.inspectionSheetCheckDescription) {
        return (
            <Grid
                container
                alignItems="center"
                style={{
                    backgroundColor: 'grey',
                    color: '#ffffff',
                    padding: '8px 16px',
                    width: '100%',
                    fontWeight: 700,
                    fontSize: 12.5,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}
            >
                <Grid item xs={12}>
                    <span style={{ color: '#ffffff', fontWeight: 700 }}>{p.inspectionSheetSectionDescription}</span>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            {flags.displayStartEvent ? (
                // OnHire-OffHire Events Body
                <Grid
                    container
                    alignItems="flex-start"
                    spacing={2}
                    style={{
                        background: hasError ? '#fff5f5' : rowBg,
                        padding: '3px 12px',
                        borderBottom: '1px solid #f1f5f9',
                        margin: 0,
                        width: '100%',
                        transition: 'background 0.2s'
                    }}
                >
                    <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
                        <div style={{ fontWeight: 600, fontSize: 12.5, color: hasError ? '#d32f2f' : '#1e293b' }}>
                            {p.inspectionSheetCheckDescription} {!!p.inspectionSheetCheckLegalRequirement && <span style={{ color: '#d32f2f' }}>*</span>}
                        </div>
                        {p.inspectionSheetCheckInformation && (
                            <div
                                className="inspectionCheckInfoHtml"
                                style={{
                                    fontWeight: 400,
                                    color: '#64748b',
                                    fontSize: 11,
                                    marginTop: 2,
                                    textAlign: 'justify',
                                    lineHeight: 1.4
                                }}
                                dangerouslySetInnerHTML={{ __html: p.inspectionSheetCheckInformation }}
                            />
                        )}
                        {p.previousNotes && (
                            <div style={{ marginTop: 4 }}>
                                <IconButton
                                    style={{
                                        background: CheckButtonsBorder[p?.previousResultCode] || '#64748b',
                                        borderRadius: 4,
                                        height: 22,
                                        padding: '0 8px',
                                        fontSize: 11
                                    }}
                                    onClick={() => handleInpectionRow(p.previousVehicleInspectionID, p.previousNotes)}
                                >
                                    <div style={{ fontSize: 11, fontWeight: 600, color: 'white', textAlign: 'left' }}>{p.previousNotes}</div>
                                </IconButton>
                            </div>
                        )}
                        {hasError && (
                            <FormHelperText error style={{ marginTop: 2 }}>
                                {isLegalReqError && 'This check is required.'}
                                {isPhotoMandatoryError && !isLegalReqError && 'Photo is mandatory.'}
                                {isDefectNoteError && !isLegalReqError && !isPhotoMandatoryError && 'Defect description is required.'}
                            </FormHelperText>
                        )}
                    </Grid>
                    <Grid
                        item
                        xl={1.5}
                        lg={1.5}
                        md={2}
                        sm={3}
                        xs={6}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 6
                        }}
                    >
                        <CustomChip
                            label={p.startResultStatus ? p.startResultStatus : 'Pending'}
                            className="btn-m"
                            style={{
                                backgroundColor: p.startBackgroundColour ? `${p.startBackgroundColour}` : '#fff',
                                color: p.startForegroundColour ? `${p.startForegroundColour}` : '#000'
                            }}
                        />
                        {!p.inspectionSheetCheckCanHidePhotoUpload && (
                            <UploadWithBadge
                                // isMandetory={isPhotoMandatoryError}
                                onClick={() => imageHandler(p.startInspectionSheetCheckResultID, p.inspectionSheetCheckID, p.startPhotosUploaded, true)}
                                count={p.startPhotosUploaded || p.basicCount}
                                state={p.startPhotosUploaded > 0 || p.basicCount > 0}
                            />
                        )}
                    </Grid>
                    <Grid item xl={2.5} lg={2.5} md={5} sm={4} xs={6}>
                        <CheckFieldType
                            fieldTypeId={p.inspectionSheetCheckFieldTypeID}
                            name="inspectionSheetCheckResultNotes"
                            onChange={changeResutNotesState(p.inspectionSheetCheckID, m.inspectionSheetCheckResultEnteredText)}
                            value={p.inspectionSheetCheckResultEnteredText}
                            btnList={state.buttonList}
                            CheckButtons={CheckButtons}
                            changeState={changeState}
                            listOptionsVM={state.listOptionsVM}
                            p={p}
                            disabled={isReadOnly}
                            listType={p.inspectionSheetCheckListTypeID}
                            photoUploadComponent={
                                !p.inspectionSheetCheckCanHidePhotoUpload && (
                                    <UploadWithBadge
                                        isMandetory={isPhotoMandatoryError}
                                        onClick={() => imageHandler(p.inspectionSheetCheckResultID, p.inspectionSheetCheckID, p.photosUploaded || p.basicCount)}
                                        count={p.photosUploaded || p.basicCount}
                                        state={p.photosUploaded > 0 || p.basicCount > 0}
                                    />
                                )
                            }
                        />
                    </Grid>
                    {!p.inspectionSheetCheckCanHideDefectDescription && (
                        <Grid
                            item
                            xl={p.defectStatusID && isRetrunedToEnginner ? 2 : 3.5}
                            lg={p.defectStatusID && isRetrunedToEnginner ? 2 : 3.5}
                            md={5}
                            sm={5}
                            xs={12}
                        >
                            <InputText
                                margin="none"
                                disabled={isReadOnly}
                                error={isDefectNoteError}
                                placeholder="Defect description"
                                name="inspectionSheetCheckResultNotes"
                                onChange={changeNotesState(p.inspectionSheetCheckID, m.inspectionSheetSectionDescription)}
                                value={p.inspectionSheetCheckResultNotes}
                                InputProps={{
                                    style: {
                                        height: 38,
                                        backgroundColor: '#fff',
                                        fontSize: 12
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        padding: '8px 12px',
                                        fontSize: 12,
                                        boxSizing: 'border-box'
                                    }
                                }}
                                style={{ backgroundColor: '#fff', fontSize: 12, margin: 0, height: 38 }}
                            />

                            {p.startNotes && (
                                <FormHelperText error style={{ marginTop: 2 }}>
                                    <IconButton
                                        style={{
                                            background: '#f1f5f9',
                                            borderRadius: 4,
                                            height: 20,
                                            padding: '0 6px',
                                            fontSize: 11
                                        }}
                                        onClick={() => handleInpectionRow(p.startVehicleInspectionID, p.startNotes)}
                                    >
                                        <div style={{ fontSize: 11, fontWeight: 600, color: '#334155', textAlign: 'left' }}>{p.startNotes}</div>
                                    </IconButton>
                                </FormHelperText>
                            )}
                        </Grid>
                    )}
                    {isRetrunedToEnginner && p.defectStatusID && (
                        <Grid item xl={2} lg={5} md={12} sm={12} xs={12}>
                            {/* {p.defectStatusID && ( */}

                            <CustomChip
                                icon={EditIcon}
                                iconFontSize={16}
                                label={p.defectStatusID !== 1 ? `${p.resultStatus} by ${p.rectifiedBy}` : 'Action'}
                                onClick={() => actionTakenHandle(p)}
                                className="btn-m"
                                style={{
                                    fontWeight: 'bold',
                                    backgroundColor: p.defectStatusID && p.rectifiedBy ? `${p.backgroundColour}` : ''
                                    // color: 'white'
                                }}
                            />

                            {/* )} */}
                        </Grid>
                    )}
                </Grid>
            ) : (
                // Inspection Events Body
                <Grid
                    container
                    spacing={1}
                    alignItems="flex-start"
                    style={{
                        background: hasError ? '#fff5f5' : rowBg,
                        padding: '3px 12px',
                        borderBottom: '1px solid #f1f5f9',
                        margin: 0,
                        width: '100%',
                        transition: 'background 0.2s'
                    }}
                >
                    <Grid item xl={5} lg={5} md={5} sm={5} xs={12}>
                        <div style={{ fontWeight: 600, fontSize: 12.5, color: hasError ? '#d32f2f' : '#1e293b' }}>
                            {p.inspectionSheetCheckDescription} {!!p.inspectionSheetCheckLegalRequirement && <span style={{ color: '#d32f2f' }}>*</span>}
                        </div>
                        {p.inspectionSheetCheckInformation && (
                            <div
                                className="inspectionCheckInfoHtml"
                                style={{
                                    fontWeight: 400,
                                    color: '#64748b',
                                    fontSize: 11,
                                    marginTop: 2,
                                    textAlign: 'justify',
                                    lineHeight: 1.4
                                }}
                                dangerouslySetInnerHTML={{ __html: p.inspectionSheetCheckInformation }}
                            />
                        )}
                        {p.previousNotes && (
                            <div style={{ marginTop: 4 }}>
                                <IconButton
                                    style={{
                                        background: CheckButtonsBorder[p?.previousResultCode] || '#64748b',
                                        borderRadius: 4,
                                        height: 22,
                                        padding: '0 8px',
                                        fontSize: 11
                                    }}
                                    onClick={() => handleInpectionRow(p.previousVehicleInspectionID, p.previousNotes)}
                                >
                                    <div style={{ fontSize: 11, fontWeight: 600, color: 'white', textAlign: 'left' }}>{p.previousNotes}</div>
                                </IconButton>
                            </div>
                        )}
                        {hasError && (
                            <FormHelperText error style={{ marginTop: 2 }}>
                                {isLegalReqError && 'This check is required.'}
                                {isPhotoMandatoryError && !isLegalReqError && 'Photo is mandatory.'}
                                {isDefectNoteError && !isLegalReqError && !isPhotoMandatoryError && 'Defect description is required.'}
                            </FormHelperText>
                        )}
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                        <CheckFieldType
                            fieldTypeId={p.inspectionSheetCheckFieldTypeID}
                            name="inspectionSheetCheckResultNotes"
                            onChange={changeResutNotesState(p.inspectionSheetCheckID, m.inspectionSheetCheckResultEnteredText)}
                            value={p.inspectionSheetCheckResultEnteredText}
                            btnList={state.buttonList}
                            CheckButtons={CheckButtons}
                            changeState={changeState}
                            listOptionsVM={state.listOptionsVM}
                            p={p}
                            disabled={isReadOnly}
                            listType={p.inspectionSheetCheckListTypeID}
                            photoUploadComponent={
                                !p.inspectionSheetCheckCanHidePhotoUpload && (
                                    <UploadWithBadge
                                        isMandetory={isPhotoMandatoryError}
                                        onClick={() => imageHandler(p.inspectionSheetCheckResultID, p.inspectionSheetCheckID, p.photosUploaded || p.basicCount)}
                                        count={p.photosUploaded || p.basicCount}
                                        state={p.photosUploaded > 0 || p.basicCount > 0}
                                    />
                                )
                            }
                        />
                    </Grid>
                    {!p.inspectionSheetCheckCanHideDefectDescription ? (
                        <Grid
                            item
                            xl={p.defectStatusID ? 2 : 4}
                            lg={p.defectStatusID ? 2 : 4}
                            md={p.defectStatusID ? 2 : 4}
                            sm={p.defectStatusID ? 2 : 4}
                            xs={12}
                        >
                            <InputText
                                margin="none"
                                disabled={isReadOnly}
                                error={isDefectNoteError}
                                placeholder="Defect description"
                                name="inspectionSheetCheckResultNotes"
                                onChange={changeNotesState(p.inspectionSheetCheckID, m.inspectionSheetSectionDescription)}
                                value={p.inspectionSheetCheckResultNotes}
                                InputProps={{
                                    style: {
                                        height: 38,
                                        backgroundColor: '#fff',
                                        fontSize: 12
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        padding: '8px 12px',
                                        fontSize: 12,
                                        boxSizing: 'border-box'
                                    }
                                }}
                                style={{ backgroundColor: '#fff', fontSize: 12, margin: 0, height: 38 }}
                            />

                            <FormHelperText
                                error
                                style={{
                                    visibility:
                                        p.inspectionSheetCheckResultOptionCode === 'D' || p.inspectionSheetCheckResultOptionCode === 'M' ? '' : 'hidden',
                                    margin: 0
                                }}
                            >
                                {state.errors?.note}
                            </FormHelperText>
                        </Grid>
                    ) : (
                        <Grid item xl={p.defectStatusID ? 2 : 4} lg={p.defectStatusID ? 2 : 4} md={12} sm={12} xs={12} />
                    )}
                    {p.defectStatusID && (
                        <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                            {/* {p.defectStatusID && ( */}

                            <CustomChip
                                icon={EditIcon}
                                iconFontSize={16}
                                label={p.defectStatusID !== 1 ? `${p.resultStatus} by ${p.rectifiedBy}` : 'Action'}
                                onClick={() => actionTakenHandle(p)}
                                className="btn-m"
                                style={{
                                    fontWeight: 'bold',
                                    backgroundColor: p.defectStatusID && p.rectifiedBy ? `${p.backgroundColour}` : ''
                                    // color: 'white'
                                }}
                            />

                            {/* )} */}
                        </Grid>
                    )}
                </Grid>
            )}
        </>
    );
});

export default InspectionCheckBody;
